import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = `${process.env.VUE_APP_BASE_URL || '/'}index.php`;

export default {
    namespaced: true,

    state: {
        filials: [],
        positions: [],
        citizenships: []
    },

    store: {
        filials: []
    },

    mutations: {
        setFilials(state, filials) {
            state.filials = filials;
        },
        setPositions(state, positions) {
            state.positions = positions;
        },
        setCitizenships(state, citizenships) {
            state.citizenships = citizenships;
        }
    },

    actions: {
        /** Филиалы */
        async loadAllFilials({rootGetters}) {
            const token = rootGetters.getAuthToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/filials`, token)
            );

            const json = await res.json();

            return json.response.map(post => ({
                value: post.id,
                label: post.name
            }));
        },

        /** Типы оплат */
        async loadPaytypes({rootGetters}) {
            const token = rootGetters.getAuthToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/paytypes`, token)
            );

            const json = await res.json();

            return json.response.map(post => ({
                value: Number(post.id),
                label: post.name
            }));
        },

        async loadFilials({ rootState, rootGetters, dispatch, commit }, params) {
            const token = rootGetters.getAuthToken;
            const { own, all } = params;

            if (!own) return [];

            const sp = { r: "api/permissions/available-filials" };
            let {userPermissions} = rootState;

            if (!userPermissions.length) {
                await dispatch("getUserPermissions", null, { root: true }).then(res => {
                    userPermissions = res.response;
                });
            }

            if (userPermissions.includes(own)) sp.own = own;
            if (all && userPermissions.includes(all)) sp.all = all;

            const search = Object.entries(sp)
                .map(([key, value]) => `${key}=${value}`)
                .join("&");

            const res = await fetch(addAuthKey(`${api_url}/?${search}`, token)).then(response =>
                response.json()
            );

            const filials = res.response.map(f => ({
                value: f.id,
                label: f.name
            }));

            commit("setFilials", filials);

            return filials;
        },

        /** Должности */
        async loadPositions({ commit, rootGetters }) {
            const token = rootGetters.getAuthToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/posts-list`, token)
            );

            const json = await res.json();

            const positions = json.response.map(post => ({
                value: post.id,
                label: post.name
            }));

            commit("setPositions", positions);

            return positions;
        },

        /** Гражданство */
        async loadCitizenships({ commit, rootGetters }) {
            const token = rootGetters.getAuthToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/citizenships-dictionary`, token)
            );

            const json = await res.json();

            const citizenships = json.response.map(с => ({
                value: с.id,
                label: с.name
            }));

            commit("setCitizenships", citizenships);

            return citizenships;
        },

        /** Правовой статус */
        async loadLawStatuses({rootGetters}) {
            const token = rootGetters.getAuthToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/law-status-dictionary`, token)
            );

            const json = await res.json();

            return json.response.map(s => ({
                value: s.id,
                label: s.name
            }));
        },

        async loadWorkStatuses({rootGetters}) {
            const token = rootGetters.getAuthToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/work-status-dictionary`, token)
            );

            const json = await res.json();

            return json.response.map(s => ({
                value: s.id,
                label: s.name
            }));
        },

        /** Типы документов */
        async loadDocTypes({rootGetters}) {
            const token = rootGetters.getAuthToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/groups-dictionary`, token)
            );

            const json = await res.json();

            return json.response.map(t => ({
                value: t.id,
                label: t.name
            }));
        },

        async loadExpirationTypes({ rootGetters }) {
            const token = rootGetters.getAuthToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/reports/workers-medical-analyses/expiration-type-list`, token)
            );

            const json = await res.json();

            return json.map(type => ({
                value: type.code,
                label: type.name
            }));
        },

        /** Наименование документов */
        async loadDocuments({rootGetters}) {
            const token = rootGetters.getAuthToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/type-documents/list`, token));

            const json = await res.json();

            const groups = [];

            const items = [];

            json.response.forEach(doc => {
                if (doc.type === "group") {
                    groups.push({
                        name: doc.id,
                        value: doc.id,
                        label: doc.name
                    });
                    if (Array.isArray(doc.docs)) {
                        doc.docs.forEach(docData => {
                            items.push({
                                label: docData.name,
                                value: docData.id,
                                group: doc.id
                            });
                        });
                    } else {
                        console.warn(`Документы для группы ${doc.id} отсутствуют или не являются массивом.`);
                    }
                } else {
                    items.push({
                        label: doc.name,
                        value: doc.id,
                        group: "other"
                    });
                }
            });

            groups.push({
                name: "other",
                id: "other",
                label: "Прочее"
            });

            return {
                groups,
                items
            };
        },

        /** Список городов */
        async loadCities({rootGetters}) {
            const token = rootGetters.getAuthToken;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/bad-address/view-city`, token));

            const json = await res.json();

            return json && json.length > 0 ? json.map((city) => ({
                label: city.title,
                value: city.id
            })) : [];
        },

        /** Список улиц */
        async loadStreets({ rootGetters }, city) {
            const token = rootGetters.getAuthToken;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/bad-address/view-street&city=${city}`, token));
            const json = await res.json();

            return json && json.length > 0
                ? json
                    .map((street) => ({
                        label: street.title,
                        value: street.id
                    }))
                : [];
        }
    }
};
